import { z } from 'zod';
import { CalendarDate, parseDate } from '@internationalized/date';

export const localDateSchema = z.instanceof(CalendarDate).nullable();

export const serverDateSchema = z.string().date().transform(parseDate);
